export default __webpack_public_path__ + "static/media/animation-vue-de-coupe.52a63c4d.gif";